<template>
    <div>
        <rkm-form
            v-if="model"
            ref="RkmFormJornada"
            show-legend
        >

            <rkm-tabs v-model="tabIndex">
                <rkm-tab
                    title="JORNADAS CADASTRADAS"
                    @click.prevent="setActive('JornadasCadastradas')"
                >
                    <tab-jornadas-cadastradas
                        ref="TabJornadasCadastradas"
                        :form="form"
                        :model="model"
                        :jornadas="jornadas"
                        :tabIndex="tabIndex"
                        :id="id"
                        @handleAlter="handleAlter"
                        @loadDays="loadDays"
                    />
                </rkm-tab>

                <rkm-tab
                    title="CADASTRAR JORNADA"
                    @click.prevent="setActive('InclusaoJornada')"
                >
                    <tab-inclusao-jornada
                        ref="TabInclusaoJornada"
                        :form="form"
                        :model="model"
                        :id="id"
                        :jornada="jornada"
                        :jornadas="jornadas"
                        :index="index"
                        :diasCalendario="diasCalendario"
                        @backTabs="backTabs"
                        @backTabsNotification="backTabsNotification"
                        @loadDiasCalendario="loadDiasCalendario"
                    />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>
    </div>
</template>

<script>

// Filters.
import formats from '@/filters/formats'

// Enums.
import diasSemana from '@/enums/geral/diasSemana'
import modulo from '@/enums/cadastro/feriado/modulo'

// Mixins.
import { error, repository, stringCase, mask, unmask, object } from '@/mixins'

// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Components.
import TabJornadasCadastradas from '@/components/transporte-paciente/jornada/components/Index'
import TabInclusaoJornada from '@/components/transporte-paciente/jornada/components/cadastro/Form'

export default {
    components: {
        TabJornadasCadastradas,
        TabInclusaoJornada,
    },
    computed: {
        dataInicial() {
            if (this.model.dataInicial) {
                return moment(this.model.dataInicial).format('DD/MM/YYYY')
            }

            return null
        },
        dataFinal() {
            if (this.model.dataFinal) {
                return moment(this.model.dataFinal).format('DD/MM/YYYY')
            }

            return null
        },
        tipoMultiplosDias() {
            return this.model.multiplosDias === true
        },
        fields() {
            return [
                {
                    key: 'geralDiaSemanaDescricao',
                    label: 'Dia da semana',
                    name: 'geralDiaSemanaDescricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'dataInicial',
                    label: 'Data e hora inicial',
                    name: 'dataInicial',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'dataFinal',
                    label: 'Data e hora final',
                    name: 'dataFinal',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                    sortable: true,
                },
            ];
        },
        validations() {
            const validacaoPeriodo = {
                dataInicial: this.model.dataInicial,
                horaInicial: this.model.horaInicial,
                dataFinal: this.model.dataFinal,
                horaFinal: this.model.horaFinal,
            }

            const validacaoPeriodoInicial = {
                ...validacaoPeriodo,
                isInicial: true
            }

            const validacaoPeriodoFinal = {
                ...validacaoPeriodo,
                isInicial: false
            }

            return {
                dataInicial: {
                    required: true,
                    periodo: validacaoPeriodoInicial
                },
                horaInicial: {
                    required: true,
                    periodo: validacaoPeriodoInicial
                },
                dataFinal: {
                    required: true,
                    periodo: validacaoPeriodoFinal
                },
                horaFinal: {
                    required: true,
                    periodo: validacaoPeriodoFinal
                },
            }
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('transportePaciente.jornada')
        }

        this.load()
    },
    data: () => ({
        form: null,
        jornadas: [],
        diasSemana: [],
        diasCalendario: [],
        dateFormatUs: 'YYYY-MM-DD',
        dateTimeFormatUs: 'YYYY-MM-DD HH:mm:ss',
        dateTimeFormatBr: 'DD/MM/YYYY HH:mm:ss',
        jornadaAlterada: false,
        model: null,
        enums: { diasSemana, modulo },
        tabIndex: 0,
        index: null,
        jornada: {
            data: null,
            diasSemana: null,
            horaInicial: '',
            horaFim: '',
            jornadaId: '',
            semanaId: null,
            selecionado: false,
            tipoId: null,
            periodo: {
                start: null,
                end: null,
            },
        },
    }),
    filters: {
        formatDateTime: formats.formatDateTime,
        formatPlaca: formats.numeroPlaca,
    },
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        disabledSemanas(){

            this.form.diasSemana.forEach(function(diaSemana) {

                diaSemana.disabled = true
            })
        },
        obterDiferencaEntreDatas(objMomentdataInicial, objMomentdataFinal) {

            return moment(objMomentdataFinal).diff(moment(objMomentdataInicial), 'days')
        },
        resetForm() {

            this.$nextTick(() => this.$refs.RkmFormJornada.resetValidator())
        },
        load() {
            this.setLoading()

            const request = this.id ?
                this.repositories.jornada.edit(this.id) :
                this.repositories.jornada.create()

            request
                .then(({ data }) => this.setData(data.form, data.model || null))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if (form) {

                this.form = Object.assign(form)
            }

            if (model) {

                this.model = Object.assign(model)

                this.model.multiplosDias = this.model.multiplosDias == 1

                this.model.dataInicial = this.form.dataAtual
                this.model.dataFinal = this.form.dataAtual

                this.jornadas = model.jornadas

                this.$nextTick().then(() => {

                    this.tabRefs = [
                        this.$refs.TabJornadasCadastradas,
                        this.$refs.TabInclusaoJornada,
                    ]
                })
            }
        },
        save() {

            this.setLoading()

            const jornadas = this.prepareData()

            const request = this.repositories.jornada.store(jornadas)

            request
                .then(response => {
                    this.showSaveNotification()
                    this.$emit('save', response)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const veiculoId = this.form.veiculo.id

            const jornadas = this.clone(this.jornadas).map(function(jornada) {

                return {
                    id: jornada.id ?? null,
                    veiculoId: veiculoId,
                    dataInicial: jornada.dataInicial,
                    dataFinal: jornada.dataFinal,
                    geralDiaSemanaId: jornada.geralDiaSemanaId,
                }
            })

            return this.camelObjectKeysToSnakeRecursive({
                veiculoId: veiculoId,
                jornadas: jornadas
            })
        },
        habilitarDiasSemana() {

            this.disabledSemanas()

            if (this.model.dataInicial && this.model.dataFinal) {

                var _dataInicialFormatada = moment(this.model.dataInicial).format(this.dateFormatUs)
                var _dataFinalFormatada = moment(this.model.dataFinal).format(this.dateFormatUs)

                const diferenca = this.obterDiferencaEntreDatas(_dataInicialFormatada, _dataFinalFormatada)

                for (let dia = 0; dia <= diferenca; dia++) {

                    const indexDiaSemana = moment(_dataInicialFormatada)
                        .add(dia, 'd')
                        .day()

                    const diaSemana = this.form.diasSemana[indexDiaSemana]

                    diaSemana.disabled = false

                    this.$set(this.form.diasSemana, indexDiaSemana, diaSemana)
                }
            }
        },
        loadDays(value) {

            this.model.jornadas = value

            let diasCalendario = []

            value.forEach(jornada => {

                const dataInicial = moment(jornada.dataInicial, this.dateFormatUs).toDate();
                const dataFinal = moment(jornada.dataFinal, this.dateFormatUs).toDate();

                if (moment(dataInicial).isSame(dataFinal, 'day')) {

                    diasCalendario.push({
                        'dates': dataInicial,
                        'title': 'icon-search',
                        'highlight': 'green'
                    });
                } else {

                    for (let data = moment(dataInicial); data <= moment(dataFinal); data.add(1, 'day')) {
                        diasCalendario.push({
                            'dates': data.toDate(),
                            'title': 'icon-search',
                            'highlight': 'green'
                        });
                    }
                }
            });

            this.form.feriados.map(feriado =>

                feriado.modulos.map(modulo => {

                    if(modulo == this.enums.modulo.TRANSPORTE_PACIENTE){

                        diasCalendario.push({
                            'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                            'highlight': 'yellow',
                            'title': feriado.tipoNome,
                            'popover':  feriado.observacao
                        })
                    }
                })
            )

            this.loadDiasCalendario(diasCalendario)
        },
        loadDiasCalendario(value) {

            this.diasCalendario = value
        },
        setActive(){

            this.setJornada()
            this.index = null
        },
        handleAlter(item, index) {

            if(item.vinculo) {
                this.showAlert('O registro possui vínculos e não pode ser editado.', 'Atenção.')
                return
            }

            this.jornada = item
            this.index = index

            this.jornada.periodo = {
                start: moment(this.jornada.dataInicial, this.dateFormatUs).toDate(),
                end: moment(this.jornada.dataFinal, this.dateFormatUs).toDate()
            };

            this.jornada.horaInicial = moment(this.jornada.dataInicial, this.dateTimeFormatUs).format('HH:mm')
            this.jornada.horaFim = moment(this.jornada.dataFinal, this.dateTimeFormatUs).format('HH:mm')

            this.jornada.tipoId = moment(this.jornada.dataInicial).isSame(this.jornada.dataFinal, 'day')
                ? null
                : 'unica'

            this.tabIndex = 1

            this.marcaDia()
        },
        backTabs(){

            if( this.index != null){

                this.tabIndex = 0
            }

            this.setJornada()
        },
        backTabsNotification(){

            this.setJornada()

            if( this.index != null){

                this.showSaveNotification('Registro da jornada selecionada alterada com sucesso.')

            } else {

                this.showSaveNotification('Registro da jornada adicionada.')
            }
        },
        setJornada(){

            this.jornada = {
                data: null,
                diasSemana: [],
                horaInicial: '',
                horaFim: '',
                jornadaId: '',
                semanaId: null,
                selecionado: false,
                tipoId: null,
                periodo: {
                    start: null,
                    end: null,
                },
            }

            this.jornada.periodo.start = this.form.dataAtual
            this.jornada.periodo.end = this.form.dataAtual

            this.model.jornadasNotSave = null
        },
        marcaDia() {

            this.jornada.diasSemana = []

            const periodo = this.jornada.periodo

            if(this.index != null){

                if(periodo.end){

                    const { start, end } = this.jornada.periodo;

                    const inicio = moment(start, this.dateFormatUs);
                    const fim = moment(end, this.dateFormatUs);

                    const ForDataInicio = inicio.toDate();
                    const ForDataFinal = fim.toDate();

                    for (let dataInserida = new Date(ForDataInicio);
                        dataInserida <= ForDataFinal;
                        dataInserida.setDate(dataInserida.getDate() + 1)) {

                        var data = moment(dataInserida, 'DD/MM/YYYY').toDate()
                        var dia = data.getDay() + 1;

                        if(!this.jornada.diasSemana.find(d => d == dia)){

                            this.jornada.diasSemana.push(dia)
                        }
                    }
                } else {

                    if (periodo.start){

                        var dataStart = moment(periodo.start, 'DD/MM/YYYY').toDate()

                        var diaStart = dataStart.getDay() + 1;

                        if(!this.jornada.diasSemana.find(d => d == diaStart)){

                            this.jornada.diasSemana.push(diaStart)
                        }
                    }
                }
            }
        }
    },
    mixins: [ error, repository, stringCase, mask, unmask, object ],
    props: {
        id: { type: [Number], default: null },
    },
    watch: {
        'model.dataInicial': function(dataInicialNew, dataInicialOld) {

            if (dataInicialNew != dataInicialOld) {

                this.model.dataMinimaFinal = dataInicialNew != '' ?
                    moment(dataInicialNew).format('DD/MM/YYYY') :
                    this.model.dataMinimaInicial

                this.model.dataFinal = ''
            }

            this.habilitarDiasSemana()
        },
        'model.dataFinal': function() {

            this.$nextTick().then(() => this.habilitarDiasSemana())
        },
        'model.jornadas': function () {

            let diasCalendario = []

            this.model.jornadas.forEach(jornada => {

                const dataInicial = moment(jornada.dataInicial, this.dateFormatUs).toDate();
                const dataFinal = moment(jornada.dataFinal, this.dateFormatUs).toDate();

                if (moment(dataInicial).isSame(dataFinal, 'day')) {

                    diasCalendario.push({
                        'dates': dataInicial,
                        'title': 'icon-search',
                        'highlight': 'green'
                    });
                } else {

                    for (let data = moment(dataInicial); data <= moment(dataFinal); data.add(1, 'day')) {
                        diasCalendario.push({
                            'dates': data.toDate(),
                            'title': 'icon-search',
                            'highlight': 'green'
                        });
                    }
                }
            });

            this.form.feriados.map(feriado =>

                feriado.modulos.map(modulo => {

                    if(modulo == this.enums.modulo.TRANSPORTE_PACIENTE){

                        diasCalendario.push({
                            'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                            'highlight': 'yellow',
                            'title': feriado.tipoNome,
                            'popover':  feriado.observacao
                        })
                    }
                })
            )

            this.loadDiasCalendario(diasCalendario)
        },
    },
}
</script>